
<div class="emicalculator">
    <div fxLayout="column" fxLayoutGap="30px" class="spacer">
        <div class="bgcolor">
            <div class="well">

                <div class="Mbottom">
                    <div class="margin-bottom">
                        <span class="left-title">
                        Loan Amount
                        </span>
                        <input type="text" class="contentfloat" (blur)="tbupdate(0)"
                        [(ngModel)]="query.amount" placeholder="Loan Amount" name="pemi.highValue" />
                    </div>
                    <ngx-slider [(value)]="pemi.value" [options]="poptions" (userChangeEnd)="update()">
                    </ngx-slider>
                </div>
    
                <hr />
    
                <div class="Mbottom">
                    <div class="margin-bottom">
                        <span class="left-title">
                        Interest Rate
                        </span>
                        <input type="text" class="contentfloat"  (blur)="tbupdate(1)"
                        [(ngModel)]="query.interest" placeholder="Interest Rate" name="remi.highValue" />
                    </div>
                    <ngx-slider [(value)]="remi.value" [options]="roptions" (userChangeEnd)="update()">
                    </ngx-slider>
                </div>
    
                <hr />
    
                <div class="Mbottom">
                    <div class="margin-bottom">
                        <span class="left-title">Loan Tenure</span>
                        <input type="text" *ngIf="yrToggel" class="contentfloat" (blur)="tbupdate(2)"
                        placeholder="Loan Tenure in Yr" [(ngModel)]="query.tenureYr" >
                        <input type="text" *ngIf="!yrToggel" class="contentfloat" (blur)="tbupdate(3)"
                        placeholder="Loan Tenure in Mo" [(ngModel)]="query.tenureMo" >
                    </div>
                    <div class="margin-bottom">
                        <div>
                            <button class="formtype" mat-button
                            class="btn-outline-secondary" [ngClass]="{'active':yrToggel}"
                                (click)="yrToggel=true;update()">YR
                            </button>
                            <button class="formtype" mat-button class="btn-outline-secondary" [ngClass]="{'active':!yrToggel}"
                                (click)="yrToggel=false;update()">MO
                            </button>
                        </div>
                    </div>
                    <ngx-slider *ngIf="yrToggel" [(value)]="temi.value" [options]="toptions" (userChangeEnd)="update()">
                    </ngx-slider>
                    <ngx-slider *ngIf="!yrToggel" [(value)]="memi.value" [options]="moptions" (userChangeEnd)="update()" class="custom-slider">
                    </ngx-slider>
                </div>


            </div>

        </div>
        <div class="bgcolor">
            <div  fxLayout="column" fxLayoutGap="10px"  class="well">
    
                <div class="Mbottom" >
                    <h5>
                        Loan EMI
                    </h5>
                    <span class="result">
                        {{result.emi || "--"}}
                    </span>
                </div>
    
                <hr />
    
                <div class="Mbottom">
                    <h5>
                        Total Interest Payable
                    </h5>
                    <span class="result">
                        {{result.interest || "--"}}
                    </span>
                </div>
    
                <hr />
                <div class="Mbottom">
                    <h5>
                        Total Payment
                    </h5>
                    <h6>
                        (Principal + Interest)
                    </h6>
                    <span class="result">
                        {{result.total || "--"}}
                    </span>
                </div>
    
    
    
            </div>
        </div>
    </div>
    
  </div>